module.exports = __webpack_public_path__ + "img/shoe-prints.4fc1b46f.svg";